// ============================================================================
// ADD-ON ENDPOINTS
// ============================================================================
// Endpoint definitions for the Add-on master module. Backend controller is
// crs.Api.Controllers.AddonModule.AddonController -> /api/v1/Addon.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/Addon';

export const addonEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  validateCode: (code: string) =>
    buildEndpointWithParams(`${BASE_PATH}/validate/code/:code`, { code }),
  validateName: (name: string) =>
    buildEndpointWithParams(`${BASE_PATH}/validate/name/:name`, { name }),
} as const;

export default addonEndpoints;
